<template>
    <v-breadcrumbs :items="getBreadcrumb" divider=">">
        <template v-slot:item="{ item }">
            <v-breadcrumbs-item
                :to="item.to"
                :disabled="item.disabled"
                ripple
                exact
                >{{ item.text }}</v-breadcrumbs-item
            >
        </template>
    </v-breadcrumbs>
</template>

<script>
export default {
    data() {
        return {
            dashboard: {
                text: this.$t('app-layout.texts.dashboard'),
                to: { name: 'dashboard' },
                disable: false,
            },
        }
    },
    computed: {
        getBreadcrumb() {
            let breadcrumbs = [this.dashboard]
            let routeBreadcrumb = this.$route.meta.breadcrumb

            if (!routeBreadcrumb) return breadcrumbs
            routeBreadcrumb.forEach(element => {
                // eslint-disable-next-line no-undef
                let breadcrumb = structuredClone(element)
                if (breadcrumb.to && breadcrumb.to.params) {
                    let rawParams = Object.entries(breadcrumb.to.params)
                    rawParams.forEach(param => {
                        breadcrumb.to.params[param[0]] = this.$route.params[
                            param[1]
                        ]
                    })
                }

                breadcrumbs.push(breadcrumb)
            })

            this.$emit('loaded')
            return breadcrumbs
        },
    },
}
</script>

<style></style>
